import { defineComponent as se, toRef as F, inject as de, ref as L, watch as ce, provide as fe, onMounted as me, computed as H, h as m, Transition as ue } from "vue";
import Y from "./ghl-ui.es1014.js";
import { formItemInjectionKey as ge } from "./ghl-ui.es870.js";
import { formItemSize as he, formItemMisc as be, formItemRule as ve } from "./ghl-ui.es1015.js";
import { formItemInstsInjectionKey as ke, formInjectionKey as pe } from "./ghl-ui.es1012.js";
import ye from "./ghl-ui.es1016.js";
import { useInjectionInstanceCollection as Re } from "./ghl-ui.es1017.js";
import we from "./ghl-ui.es854.js";
import { createId as G } from "./ghl-ui.es939.js";
import X from "./ghl-ui.es855.js";
import { createKey as S } from "./ghl-ui.es384.js";
import { useThemeClass as Se } from "./ghl-ui.es857.js";
import { resolveWrappedSlot as _e } from "./ghl-ui.es860.js";
import $e from "./ghl-ui.es1013.js";
import xe from "./ghl-ui.es1018.js";
import { warn as J } from "./ghl-ui.es853.js";
var Q = globalThis && globalThis.__awaiter || function(l, e, u, t) {
  function b(o) {
    return o instanceof u ? o : new u(function(k) {
      k(o);
    });
  }
  return new (u || (u = Promise))(function(o, k) {
    function C(r) {
      try {
        g(t.next(r));
      } catch (s) {
        k(s);
      }
    }
    function v(r) {
      try {
        g(t.throw(r));
      } catch (s) {
        k(s);
      }
    }
    function g(r) {
      r.done ? o(r.value) : b(r.value).then(C, v);
    }
    g((t = t.apply(l, e || [])).next());
  });
};
const Ce = Object.assign(Object.assign({}, X.props), {
  label: String,
  labelWidth: [Number, String],
  labelStyle: [String, Object],
  labelAlign: String,
  labelPlacement: String,
  path: String,
  first: Boolean,
  rulePath: String,
  required: Boolean,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: void 0
  },
  rule: [Object, Array],
  size: String,
  ignorePathChange: Boolean,
  validationStatus: String,
  feedback: String,
  showLabel: {
    type: Boolean,
    default: void 0
  },
  labelProps: Object
});
function U(l, e) {
  return (...u) => {
    try {
      const t = l(...u);
      return !e && (typeof t == "boolean" || t instanceof Error || Array.isArray(t)) || // Error[]
      t != null && t.then ? t : (t === void 0 || J("form-item/validate", `You return a ${typeof t} typed value in the validator method, which is not recommended. Please use ` + (e ? "`Promise`" : "`boolean`, `Error` or `Promise`") + " typed value instead."), !0);
    } catch (t) {
      J("form-item/validate", "An error is catched in the validation, so the validation won't be done. Your callback in `validate` method of `n-form` or `n-form-item` won't be called in this validation."), console.error(t);
      return;
    }
  };
}
const Ke = se({
  name: "FormItem",
  props: Ce,
  setup(l) {
    Re(ke, "formItems", F(l, "path"));
    const {
      mergedClsPrefixRef: e,
      inlineThemeDisabled: u
    } = we(l), t = de(pe, null), b = he(l), o = be(l), {
      validationErrored: k,
      validationWarned: C
    } = o, {
      mergedRequired: v,
      mergedRules: g
    } = ve(l), {
      mergedSize: r
    } = b, {
      mergedLabelPlacement: s,
      mergedLabelAlign: p,
      mergedRequireMarkPlacement: B
    } = o, j = L([]), N = L(G()), Z = t ? F(t.props, "disabled") : L(!1), ee = X("Form", "-form-item", ye, $e, l, e);
    ce(F(l, "path"), () => {
      l.ignorePathChange || T();
    });
    function T() {
      j.value = [], k.value = !1, C.value = !1, l.feedback && (N.value = G());
    }
    function te() {
      P("blur");
    }
    function ae() {
      P("change");
    }
    function ne() {
      P("focus");
    }
    function ie() {
      P("input");
    }
    function le(a, h) {
      return Q(this, void 0, void 0, function* () {
        let c, f, _, $;
        return typeof a == "string" ? (c = a, f = h) : a !== null && typeof a == "object" && (c = a.trigger, f = a.callback, _ = a.shouldRuleBeApplied, $ = a.options), yield new Promise((M, z) => {
          P(c, _, $).then(({
            valid: A,
            errors: w,
            warnings: y
          }) => {
            A ? (f && f(void 0, {
              warnings: y
            }), M({
              warnings: y
            })) : (f && f(w, {
              warnings: y
            }), z(w));
          });
        });
      });
    }
    const P = (a = null, h = () => !0, c = {
      suppressWarning: !0
    }) => Q(this, void 0, void 0, function* () {
      const {
        path: f
      } = l;
      c ? c.first || (c.first = l.first) : c = {};
      const {
        value: _
      } = g, $ = t ? xe(t.props.model, f || "") : void 0, M = {}, z = {}, A = (a ? _.filter((n) => Array.isArray(n.trigger) ? n.trigger.includes(a) : n.trigger === a) : _).filter(h).map((n, d) => {
        const i = Object.assign({}, n);
        if (i.validator && (i.validator = U(i.validator, !1)), i.asyncValidator && (i.asyncValidator = U(i.asyncValidator, !0)), i.renderMessage) {
          const x = `__renderMessage__${d}`;
          z[x] = i.message, i.message = x, M[x] = i.renderMessage;
        }
        return i;
      }), w = A.filter((n) => n.level !== "warning"), y = A.filter((n) => n.level === "warning"), V = f ?? "__n_no_path__", W = new Y({
        [V]: w
      }), O = new Y({
        [V]: y
      }), {
        validateMessages: E
      } = (t == null ? void 0 : t.props) || {};
      E && (W.messages(E), O.messages(E));
      const q = (n) => {
        j.value = n.map((d) => {
          const i = (d == null ? void 0 : d.message) || "";
          return {
            key: i,
            render: () => i.startsWith("__renderMessage__") ? M[i]() : i
          };
        }), n.forEach((d) => {
          var i;
          !((i = d.message) === null || i === void 0) && i.startsWith("__renderMessage__") && (d.message = z[d.message]);
        });
      }, R = {
        valid: !0,
        errors: void 0,
        warnings: void 0
      };
      if (w.length) {
        const n = yield new Promise((d) => {
          W.validate({
            [V]: $
          }, c, d);
        });
        n != null && n.length && (k.value = !0, R.valid = !1, R.errors = n, q(n));
      }
      if (y.length && !R.errors) {
        const n = yield new Promise((d) => {
          O.validate({
            [V]: $
          }, c, d);
        });
        n != null && n.length && (q(n), C.value = !0, R.warnings = n);
      }
      return w.length + y.length > 0 && !R.errors && !R.warnings && T(), R;
    });
    fe(ge, {
      path: F(l, "path"),
      disabled: Z,
      mergedSize: b.mergedSize,
      mergedValidationStatus: o.mergedValidationStatus,
      restoreValidation: T,
      handleContentBlur: te,
      handleContentChange: ae,
      handleContentFocus: ne,
      handleContentInput: ie
    });
    const re = {
      validate: le,
      restoreValidation: T,
      internalValidate: P
    }, K = L(null);
    me(() => {
      if (!o.isAutoLabelWidth.value)
        return;
      const a = K.value;
      if (a !== null) {
        const h = a.style.whiteSpace;
        a.style.whiteSpace = "nowrap", a.style.width = "", t == null || t.deriveMaxChildLabelWidth(Number(getComputedStyle(a).width.slice(0, -2))), a.style.whiteSpace = h;
      }
    });
    const D = H(() => {
      var a;
      const {
        value: h
      } = r, {
        value: c
      } = s, f = c === "top" ? "vertical" : "horizontal", {
        common: {
          cubicBezierEaseInOut: _
        },
        self: {
          labelTextColor: $,
          asteriskColor: M,
          lineHeight: z,
          feedbackTextColor: A,
          feedbackTextColorWarning: w,
          feedbackTextColorError: y,
          feedbackPadding: V,
          labelFontWeight: W,
          [S("labelHeight", h)]: O,
          [S("blankHeight", h)]: E,
          [S("feedbackFontSize", h)]: q,
          [S("feedbackHeight", h)]: R,
          [S("labelPadding", f)]: n,
          [S("labelTextAlign", f)]: d,
          [S(S("labelFontSize", c), h)]: i
        }
      } = ee.value;
      let x = (a = p.value) !== null && a !== void 0 ? a : d;
      return c === "top" && (x = x === "right" ? "flex-end" : "flex-start"), {
        "--n-bezier": _,
        "--n-line-height": z,
        "--n-blank-height": E,
        "--n-label-font-size": i,
        "--n-label-text-align": x,
        "--n-label-height": O,
        "--n-label-padding": n,
        "--n-label-font-weight": W,
        "--n-asterisk-color": M,
        "--n-label-text-color": $,
        "--n-feedback-padding": V,
        "--n-feedback-font-size": q,
        "--n-feedback-height": R,
        "--n-feedback-text-color": A,
        "--n-feedback-text-color-warning": w,
        "--n-feedback-text-color-error": y
      };
    }), I = u ? Se("form-item", H(() => {
      var a;
      return `${r.value[0]}${s.value[0]}${((a = p.value) === null || a === void 0 ? void 0 : a[0]) || ""}`;
    }), D, l) : void 0, oe = H(() => s.value === "left" && B.value === "left" && p.value === "left");
    return Object.assign(Object.assign(Object.assign(Object.assign({
      labelElementRef: K,
      mergedClsPrefix: e,
      mergedRequired: v,
      feedbackId: N,
      renderExplains: j,
      reverseColSpace: oe
    }, o), b), re), {
      cssVars: u ? void 0 : D,
      themeClass: I == null ? void 0 : I.themeClass,
      onRender: I == null ? void 0 : I.onRender
    });
  },
  render() {
    const {
      $slots: l,
      mergedClsPrefix: e,
      mergedShowLabel: u,
      mergedShowRequireMark: t,
      mergedRequireMarkPlacement: b,
      onRender: o
    } = this, k = t !== void 0 ? t : this.mergedRequired;
    o == null || o();
    const C = () => {
      const v = this.$slots.label ? this.$slots.label() : this.label;
      if (!v)
        return null;
      const g = m("span", {
        class: `${e}-form-item-label__text`
      }, v), r = k ? m("span", {
        class: `${e}-form-item-label__asterisk`
      }, b !== "left" ? " *" : "* ") : b === "right-hanging" && m("span", {
        class: `${e}-form-item-label__asterisk-placeholder`
      }, " *"), {
        labelProps: s
      } = this;
      return m("label", Object.assign({}, s, {
        class: [s == null ? void 0 : s.class, `${e}-form-item-label`, `${e}-form-item-label--${b}-mark`, this.reverseColSpace && `${e}-form-item-label--reverse-columns-space`],
        style: this.mergedLabelStyle,
        ref: "labelElementRef"
      }), b === "left" ? [r, g] : [g, r]);
    };
    return m("div", {
      class: [`${e}-form-item`, this.themeClass, `${e}-form-item--${this.mergedSize}-size`, `${e}-form-item--${this.mergedLabelPlacement}-labelled`, this.isAutoLabelWidth && `${e}-form-item--auto-label-width`, !u && `${e}-form-item--no-label`],
      style: this.cssVars
    }, u && C(), m("div", {
      class: [`${e}-form-item-blank`, this.mergedValidationStatus && `${e}-form-item-blank--${this.mergedValidationStatus}`]
    }, l), this.mergedShowFeedback ? m("div", {
      key: this.feedbackId,
      class: `${e}-form-item-feedback-wrapper`
    }, m(ue, {
      name: "fade-down-transition",
      mode: "out-in"
    }, {
      default: () => {
        const {
          mergedValidationStatus: v
        } = this;
        return _e(l.feedback, (g) => {
          var r;
          const {
            feedback: s
          } = this, p = g || s ? m("div", {
            key: "__feedback__",
            class: `${e}-form-item-feedback__line`
          }, g || s) : this.renderExplains.length ? (r = this.renderExplains) === null || r === void 0 ? void 0 : r.map(({
            key: B,
            render: j
          }) => m("div", {
            key: B,
            class: `${e}-form-item-feedback__line`
          }, j())) : null;
          return p ? v === "warning" ? m("div", {
            key: "controlled-warning",
            class: `${e}-form-item-feedback ${e}-form-item-feedback--warning`
          }, p) : v === "error" ? m("div", {
            key: "controlled-error",
            class: `${e}-form-item-feedback ${e}-form-item-feedback--error`
          }, p) : v === "success" ? m("div", {
            key: "controlled-success",
            class: `${e}-form-item-feedback ${e}-form-item-feedback--success`
          }, p) : m("div", {
            key: "controlled-default",
            class: `${e}-form-item-feedback`
          }, p) : null;
        });
      }
    })) : null);
  }
});
export {
  Ke as default,
  Ce as formItemProps
};
